import React from "react";
import { REGISTER_URL } from "../../data/content";

// Phones only (CSS hides it above 700px): the trial button stays one tap away.
export default function StickyCta() {
  return (
    <div className="sticky-cta" aria-label="Start free trial">
      <span>14 days free<br />No card</span>
      <a className="btn btn-green" href={REGISTER_URL} data-testid="sticky-trial-cta">Start free trial</a>
    </div>
  );
}
